/* DECOMURA: podgląd zdjęć Dawn i doczytywanie list.
   Mechanizmy z dcm-layout.js dopasowane do obecnego HTML.
   Historia zawiera numery stron i klucze, nigdy HTML ani ceny. */
(function () {
  'use strict';
  if (window.__dcmStagingInit) return;
  window.__dcmStagingInit = true;
  var version = 'staging-2026-09-08';
  var texts = {};
  try { texts = JSON.parse(document.getElementById('dcm-staging-i18n').textContent); } catch (_) {}
  function t(key, values) {
    var result = texts[key] || '';
    Object.keys(values || {}).forEach(function (name) { result = result.replaceAll('[' + name + ']', String(values[name])); });
    return result;
  }
  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event, layout_version: version }, data || {}));
    } catch (_) { /* Pomiar nie może zatrzymać interfejsu. */ }
  }

  /* Wysokosc naglowka pod przyklejony pasek okruszkow. Dawn liczy `--header-height` TYLKO przy
     starcie i przy przejsciu przez 990 px — nie ma nasluchu na `resize`. Przy zwyklej zmianie
     szerokosci okna (zawiniecie menu, zmiana ukladu) wartosc zostaje nieaktualna i przyklejony pasek
     odkleja sie od belki albo na nia wchodzi. Trzymamy wlasna zmienna na obserwatorze rozmiaru;
     regula przyklejenia bierze ja z zapasem na `--header-height`. */
  (function () {
    var naglowek = document.querySelector('.section-header');
    if (!naglowek) return;
    function zapisz() {
      document.documentElement.style.setProperty('--dcm-naglowek', naglowek.offsetHeight + 'px');
    }
    zapisz();
    if (window.ResizeObserver) new ResizeObserver(zapisz).observe(naglowek);
    else window.addEventListener('resize', zapisz, { passive: true });
  })();

  function initMobileMarquees() {
    var mobile = matchMedia('(max-width: 749px)');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('[data-dcm-marquee]').forEach(function (root) {
      if (!root || root.dataset.dcmMobileMarqueeReady) return;
      var viewport = root.querySelector('.dcm-marquee__viewport');
      var first = root.querySelector('.dcm-marquee__track:not(.dcm-marquee__track--copy)');
      if (!viewport || !first) return;
      root.dataset.dcmMobileMarqueeReady = 'true';
      var paused = false, visible = true, acc = 0, resumeT = null;
      function width() { return Math.round(first.getBoundingClientRect().width || first.scrollWidth || 0); }
      function active() { return mobile.matches && !reduce.matches && width() > viewport.clientWidth + 8; }
      function pause() { paused = true; clearTimeout(resumeT); }
      function resumeSoon() { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 1800); }
      function normalize() {
        var w = width();
        if (!active() || !(w > 0)) return;
        if (viewport.scrollLeft >= w) viewport.scrollLeft -= w;
      }
      viewport.addEventListener('pointerdown', pause, { passive: true });
      viewport.addEventListener('pointerup', resumeSoon, { passive: true });
      viewport.addEventListener('pointercancel', resumeSoon, { passive: true });
      viewport.addEventListener('touchend', resumeSoon, { passive: true });
      viewport.addEventListener('scroll', normalize, { passive: true });
      viewport.addEventListener('focusin', pause);
      viewport.addEventListener('focusout', resumeSoon);
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) { visible = entries[0] ? entries[0].isIntersecting : true; });
        observer.observe(root);
      }
      function frame() {
        if (!root.isConnected) { clearTimeout(resumeT); return; }
        if (active() && visible && !document.hidden && !paused) {
          acc += 0.35;
          var delta = acc | 0;
          if (delta) { viewport.scrollLeft += delta; acc -= delta; normalize(); }
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  /* Mobile: klient może przeciągnąć pływający przycisk Maia; pozycję trzymamy lokalnie w przeglądarce. */
  (function () {
    var KEY = 'dcm-maia-mobile-pos-v1';
    var mobile = matchMedia('(max-width: 749px) and (pointer: coarse)');
    function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
    function readPos() {
      try { var pos = JSON.parse(localStorage.getItem(KEY) || 'null'); return pos && Number.isFinite(pos.x) && Number.isFinite(pos.y) ? pos : null; }
      catch (_) { return null; }
    }
    function savePos(pos) { try { localStorage.setItem(KEY, JSON.stringify(pos)); } catch (_) {} }
    function applyPos(el, pos) {
      if (!el || !pos) return;
      var width = el.offsetWidth || 56, height = el.offsetHeight || 56;
      var x = clamp(pos.x, 8, Math.max(8, innerWidth - width - 8));
      var y = clamp(pos.y, 8, Math.max(8, innerHeight - height - 8));
      el.style.left = x + 'px';
      el.style.top = y + 'px';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
    }
    function initBubble(el) {
      if (!el || el.dataset.dcmMaiaDragReady || !mobile.matches) return;
      el.dataset.dcmMaiaDragReady = 'true';
      applyPos(el, readPos());
      var drag = null;
      el.addEventListener('pointerdown', function (event) {
        if (!mobile.matches || event.pointerType === 'mouse') return;
        var rect = el.getBoundingClientRect();
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false };
        el.style.transition = 'none';
        try { el.setPointerCapture(event.pointerId); } catch (_) {}
      }, { passive: true });
      el.addEventListener('pointermove', function (event) {
        if (!drag || drag.id !== event.pointerId) return;
        var dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (!drag.moved && Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        drag.moved = true;
        event.preventDefault();
        applyPos(el, { x: drag.left + dx, y: drag.top + dy });
      }, { passive: false });
      function endDrag(event) {
        if (!drag || drag.id !== event.pointerId) return;
        var moved = drag.moved;
        drag = null;
        el.style.transition = '';
        try { el.releasePointerCapture(event.pointerId); } catch (_) {}
        if (!moved) return;
        var rect = el.getBoundingClientRect();
        savePos({ x: rect.left, y: rect.top });
        el.dataset.dcmMaiaDragged = '1';
        setTimeout(function () { delete el.dataset.dcmMaiaDragged; }, 350);
      }
      el.addEventListener('pointerup', endDrag, { passive: true });
      el.addEventListener('pointercancel', endDrag, { passive: true });
      el.addEventListener('click', function (event) {
        if (!el.dataset.dcmMaiaDragged) return;
        delete el.dataset.dcmMaiaDragged;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }
    function initMaia() { initBubble(document.getElementById('maia-bubble')); }
    function resizeMaia() { var bubble = document.getElementById('maia-bubble'); if (bubble && mobile.matches) applyPos(bubble, readPos() || { x: bubble.getBoundingClientRect().left, y: bubble.getBoundingClientRect().top }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMaia, { once: true });
    else initMaia();
    var observer = new MutationObserver(function (mutations) {
      if (!mobile.matches) return;
      if (mutations.some(function (mutation) { return Array.from(mutation.addedNodes).some(function (node) { return node.nodeType === 1 && (node.id === 'maia-bubble' || node.querySelector && node.querySelector('#maia-bubble')); }); })) initMaia();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    mobile.addEventListener('change', initMaia);
    addEventListener('resize', resizeMaia, { passive: true });
    addEventListener('pageshow', initMaia);
  })();

  var finePointer = matchMedia('(any-hover: hover) and (any-pointer: fine)');
  var reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  var hovers = new WeakSet();
  function preview(card) { return card && card.querySelector('[data-dcm-preview]'); }
  function frames(card) {
    var media = preview(card);
    return media && media.dataset.dcmFrames ? media.dataset.dcmFrames.split(',').filter(Boolean) : [];
  }
  function showFrame(card, mode, source) {
    var media = preview(card);
    if (!media || ['room'].concat(frames(card)).indexOf(mode) < 0) return;
    var image = media.querySelector('[data-dcm-frame="' + mode + '"]');
    if (!image) return;
    var previous = media.dataset.chosen || 'room';
    if (media.dataset.requested === mode && (source !== 'manual' || previous === mode)) return;
    if (source === 'manual') media.dataset.chosen = mode;
    media.dataset.requested = mode;
    // Znacznik ustawiamy tu, a nie przy najechaniu: strzalki i gest palcem tez go potrzebuja.
    // Kreseczki sa dla klatek BEZ aranzacji (tyle, ile wizualizacji plus wzor), wiec na aranzacji
    // indeks wychodzi -1 i zadna nie jest zapalona — tak samo jak po zjechaniu myszka z kafla.
    markSegment(card, frames(card).indexOf(mode));
    var status = card.querySelector('[data-dcm-image-status]');
    var all = ['room'].concat(frames(card));
    function announce(shown) {
      // Numer i suma z tej samej listy: wcześniej pierwsza klatka po aranżacji też dostawała „1”,
    // a mianownik zmieniał się w trakcie przeglądania.
    if (source === 'manual' && status && shown) status.textContent = t('image_status', { name: shown.alt, number: all.indexOf(shown.dataset.dcmFrame) + 1, total: all.length });
    }
    if (source === 'manual' && status) status.textContent = t('loading');
    function reveal() {
      if (!media.isConnected || media.dataset.requested !== mode) return;
      media.dataset.show = mode;
      media.querySelectorAll('[data-dcm-frame]').forEach(function (item) {
        item.classList.toggle('is-active', item === image);
        item.setAttribute('aria-hidden', String(item !== image));
      });
      announce(image);
    }
    window.DcmVisuals.ready(image, true).then(function (ok) {
      if (ok) reveal();
      else if (media.dataset.requested === mode) {
        media.dataset.requested = media.dataset.show;
        markSegment(card, frames(card).indexOf(media.dataset.show || 'room'));
        announce(media.querySelector('.dcm-frame.is-active'));
      }
    });
    if (source !== 'manual' || previous === mode) return;
    track('card_image_change', { item_id: media.dataset.handle, mode: mode, card_variant: 'Dawn' });
  }
  var PROG_GESTU = 30;
  var PROG_RUCHU = 10;
  function oznaczGest(media) {
    if (!media) return;
    media.dataset.gest = '1';
    setTimeout(function () {
      if (media.dataset.gest === '1') delete media.dataset.gest;
    }, 500);
  }
  function przesunKlatke(card, krok) {
    var media = preview(card);
    if (!media) return;
    if (window.DcmVisuals && window.DcmVisuals.przygotuj) window.DcmVisuals.przygotuj(media);
    var list = ['room'].concat(frames(card));
    if (list.length < 2) return;
    var index = list.indexOf(media.dataset.chosen || 'room');
    if (index < 0) index = 0;
    showFrame(card, list[(index + krok + list.length) % list.length], 'manual');
  }
  /* Przesuniecie palcem po kaflu. Klatki leza w odsylaczu, wiec gest musi trzy rzeczy naraz:
     nie przewijac strony w poziomie (`touch-action: pan-y` w stylach), nie uruchamiac przeciagania
     odsylacza i nie konczyc sie wejsciem na karte produktu. Ostatnie zalatwia znacznik `gest`,
     ktory obsluga klikniecia czyta i wtedy blokuje przejscie. Mysz pomijamy: tam dziala najechanie. */
  var gest = null;
  document.addEventListener('pointerdown', function (event) {
    if (!(event.target instanceof Element) || event.pointerType === 'mouse') return;
    var media = event.target.closest('[data-dcm-preview]');
    if (!media) return;
    delete media.dataset.gest;
    gest = { media: media, x: event.clientX, y: event.clientY, id: event.pointerId, moved: false };
  }, { passive: true });
  document.addEventListener('pointermove', function (event) {
    if (!gest || event.pointerId !== gest.id) return;
    var dx = event.clientX - gest.x, dy = event.clientY - gest.y;
    if (Math.max(Math.abs(dx), Math.abs(dy)) >= PROG_RUCHU) gest.moved = true;
  }, { passive: true });
  document.addEventListener('pointerup', function (event) {
    if (!gest || event.pointerId !== gest.id) { gest = null; return; }
    var media = gest.media;
    var dx = event.clientX - gest.x, dy = event.clientY - gest.y;
    var moved = gest.moved || Math.max(Math.abs(dx), Math.abs(dy)) >= PROG_RUCHU;
    gest = null;
    if (moved) oznaczGest(media);
    if (Math.abs(dx) < PROG_GESTU || Math.abs(dx) <= Math.abs(dy)) return;
    przesunKlatke(media.closest('[data-dcm-dawn-card]'), dx < 0 ? 1 : -1);
  }, { passive: true });
  document.addEventListener('pointercancel', function () {
    if (gest && gest.moved) oznaczGest(gest.media);
    gest = null;
  }, { passive: true });
  document.addEventListener('dragstart', function (event) {
    if (event.target instanceof Element && event.target.closest('[data-dcm-preview]')) event.preventDefault();
  });

  /* Fokus z KLAWIATURY ma wygrywac z mysza: kto chodzi tabem, ten steruje kaflem sam i najechanie
     nie powinno mu tego zabierac. Ale klik mysza w serce TEZ zostawia fokus wewnatrz kafla — i az do
     tej poprawki gasil podglady (wzor + dwie wizualizacje) do konca wizyty. `:focus-visible` jest
     dokladnie tym rozroznieniem: przegladarka ustawia go po klawiaturze, a po kliknieciu w przycisk nie. */
  function fokusKlawiatury(card) {
    if (!card) return false;
    try { return !!card.querySelector(':focus-visible'); }
    catch (_) { return card.contains(document.activeElement); }
  }

  function markSegment(card, index) {
    card.querySelectorAll('[data-dcm-segments] span').forEach(function (bar, i) { bar.classList.toggle('is-active', i === index); });
  }
  function leaveCard(card) {
    if (!card || !hovers.has(card)) return;
    hovers.delete(card);
    card.classList.remove('dcm-card--hovering');
    preview(card).dataset.chosen = 'room';
    showFrame(card, 'room', 'silent');
  }
  function hoverCard(event) {
    if (!(event.target instanceof Element) || event.pointerType !== 'mouse' || event.buttons) return;
    var card = event.target.closest('[data-dcm-dawn-card]');
    var media = preview(card);
    if (!media || !finePointer.matches || reducedMotion.matches || fokusKlawiatury(card)) { leaveCard(card); return; }
    if (event.target.closest('button')) return;
    var rect = media.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) { leaveCard(card); return; }
    var list = frames(card);
    if (!list.length || !rect.width) return;
    hovers.add(card);
    if (window.DcmVisuals && window.DcmVisuals.przygotuj) window.DcmVisuals.przygotuj(media);
    card.classList.add('dcm-card--hovering');
    var index = Math.max(0, Math.min(list.length - 1, Math.floor((event.clientX - rect.left) / rect.width * list.length)));
    showFrame(card, list[index], 'hover');
  }
  document.addEventListener('pointerover', hoverCard, { passive: true });
  document.addEventListener('pointermove', hoverCard, { passive: true });
  document.addEventListener('pointerout', function (event) {
    if (!(event.target instanceof Element)) return;
    var card = event.target.closest('[data-dcm-dawn-card]');
    if (card && (!(event.relatedTarget instanceof Node) || !card.contains(event.relatedTarget))) leaveCard(card);
  }, { passive: true });
  document.addEventListener('focusin', function (event) {
    if (!(event.target instanceof Element)) return;
    var kafel = event.target.closest('[data-dcm-dawn-card]');
    if (kafel && window.DcmVisuals && window.DcmVisuals.przygotuj) window.DcmVisuals.przygotuj(preview(kafel));
    if (fokusKlawiatury(kafel)) leaveCard(kafel);
  });
  reducedMotion.addEventListener('change', function () { document.querySelectorAll('.dcm-card--hovering').forEach(leaveCard); });

  /* Jeden odczyt sekcji naraz, kontrola wersji listy i powrót z historii. */
  var AUTO_PORCJE = 3;
  var activeRequest = null;
  var restoringList = null;
  var restoredLists = new WeakSet();
  var observedSentinels = new Set();
  var autoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var box = entry.target.closest('[data-dcm-more]');
      if (!box || box.dataset.autoPaused === 'true' || restoringList === currentList(box)) return;
      var button = box.querySelector('[data-dcm-load]');
      if (!button || button.hidden) return;
      // Bez ogranicznika stopka odsuwała się przy każdym dojściu do dołu i przy 127 stronach
      // była nieosiągalna. Po trzech porcjach oddajemy sterowanie przyciskowi.
      var porcje = Number(box.dataset.dcmAuto || 0);
      if (porcje >= AUTO_PORCJE) return;
      box.dataset.dcmAuto = porcje + 1;
      loadMore(button, 'auto');
    });
  }, { rootMargin: '400px 0px' }) : null;
  // Na jednej stronie może być kilka list (galeria kolekcji i listing wzorów) — szukamy w obrębie własnego kontenera.
  function currentList(ctx) { var scope = ctx && ctx.closest ? ctx.closest('[data-dcm-listing]') : null; return (scope && scope.querySelector('[data-dcm-list]')) || document.querySelector('[data-dcm-list]'); }
  function routeKey() { return location.pathname + location.search; }
  function viewKey(list) { return routeKey() + '|' + list.dataset.section + '|' + list.dataset.country + '|' + list.dataset.currency; }
  function listItems(list) { return Array.from(list.children).filter(function (item) { return item.hasAttribute('data-dcm-key'); }); }
  function boxFor(list) { return list && list.closest('[data-dcm-listing]').querySelector('[data-dcm-more]'); }
  function itemLink(item) {
    if (!item) return null;
    // Dawn ma również ukryty odnośnik tytułu; fokus musi trafić w widoczny element.
    // Odsyłacz podglądu jest poza drzewem dostępności — fokus po doczytaniu ma trafić w tytuł.
    return Array.from(item.querySelectorAll('a[href]')).find(function (link) {
      return link.getAttribute('aria-hidden') !== 'true' && link.getClientRects().length && getComputedStyle(link).visibility !== 'hidden';
    }) || null;
  }
  function saveView(extra, ctx) {
    var list = currentList(ctx);
    if (!list || restoringList === list) return;
    try {
      var state = Object.assign({}, history.state || {});
      state.searchParams = location.search.slice(1);
      state.dcmListing = Object.assign({ key: viewKey(list), lastPage: Number(list.dataset.page) }, extra || {});
      history.replaceState(state, '', location.href);
    } catch (_) { /* Zwykła nawigacja działa także bez pamięci historii. */ }
  }
  function rearm(box) {
    var sentinel = box.querySelector('[data-dcm-sentinel]');
    if (!autoObserver || !sentinel || !sentinel.isConnected || box.dataset.autoPaused === 'true') return;
    autoObserver.unobserve(sentinel);
    autoObserver.observe(sentinel);
  }
  async function loadMore(button, source) {
    var box = button.closest('[data-dcm-more]'), list = currentList(button);
    // Kliknięcie w przycisk jest zgodą na kolejne porcje automatyczne.
    if (box && source === 'manual') delete box.dataset.dcmAuto;
    if (!box || !list || !button.dataset.next || button.disabled || (activeRequest && activeRequest.list === list)) return false;
    if (!box.isConnected || boxFor(list) !== box) return false;
    // Stara lista nie może doczytywać pozycji w trakcie zmiany filtrów.
    if (list.closest('.collection.loading')) return false;
    if (activeRequest) activeRequest.controller.abort();
    var next, url, pageNumber;
    try {
      next = new URL(button.dataset.next, location.href);
      var base = list.dataset.basePath || '';
      if (next.origin !== location.origin || (next.pathname !== location.pathname && next.pathname !== base)) return false;
      pageNumber = Number(next.searchParams.get('page'));
      if (!Number.isInteger(pageNumber) || pageNumber !== Number(list.dataset.page) + 1) return false;
      // Lista osadzona poza stroną kolekcji (strona główna) doczytuje ze strony kolekcji z bieżącymi filtrami z adresu.
      url = base ? new URL(base + location.search, location.origin) : new URL(location.href);
      url.searchParams.set('page', String(pageNumber));
      url.searchParams.set('section_id', list.dataset.section);
    } catch (_) { return false; }
    var request = { list: list, route: routeKey(), controller: new AbortController() };
    activeRequest = request;
    function isCurrent() { return activeRequest === request && list.isConnected && currentList(box) === list && routeKey() === request.route; }
    var timeout = setTimeout(function () { request.controller.abort(); }, 15000);
    var error = box.querySelector('[data-dcm-error]');
    var status = box.querySelector('[data-dcm-status]');
    if (error) error.hidden = true;
    box.classList.remove('dcm-more--error');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = t('loading');
    if (source !== 'restore') track('load_more_start', { page: pageNumber, shown: listItems(list).length, total: Number(list.dataset.total), source: source });
    try {
      var response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: request.controller.signal });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      if (!isCurrent()) return false;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var incoming = doc.querySelector('[data-dcm-list]');
      if (!incoming || incoming.dataset.section !== list.dataset.section || Number(incoming.dataset.page) !== pageNumber) throw new Error('Nieprawidłowa odpowiedź sekcji');
      var candidates = listItems(incoming);
      if (!candidates.length) throw new Error('Pusta odpowiedź sekcji');
      var keys = new Set(listItems(list).map(function (item) { return item.dataset.dcmKey; }));
      var items = candidates.filter(function (item) {
        if (!item.dataset.dcmKey) throw new Error('Brak klucza pozycji');
        if (keys.has(item.dataset.dcmKey)) return false;
        keys.add(item.dataset.dcmKey);
        return true;
      });
      var fragment = document.createDocumentFragment();
      items.forEach(function (item) {
        item.querySelectorAll('.scroll-trigger').forEach(function (el) { el.classList.add('scroll-trigger--cancel'); });
        item.classList.add('scroll-trigger--cancel');
        fragment.appendChild(item);
      });
      list.appendChild(fragment);
      ['page','pages','total'].forEach(function (name) { list.dataset[name] = incoming.dataset[name]; });
      var incomingBox = boxFor(incoming);
      var nextButton = incomingBox && incomingBox.querySelector('[data-dcm-load]');
      var nextUrl = nextButton && nextButton.dataset.next;
      button.dataset.next = nextUrl || '';
      button.hidden = !nextUrl;
      var end = box.querySelector('[data-dcm-end]');
      if (end) end.hidden = Boolean(nextUrl);
      var oldPagination = list.closest('[data-dcm-listing]').querySelector('.pagination-wrapper');
      var newPagination = incoming.closest('[data-dcm-listing]').querySelector('.pagination-wrapper');
      if (oldPagination && newPagination) oldPagination.replaceWith(newPagination);
      else if (oldPagination) oldPagination.remove();
      var shown = listItems(list).length;
      if (status) status.textContent = t('loaded', { count: items.length, shown: shown, total: list.dataset.total });
      delete box.dataset.autoPaused;
      if (source !== 'restore') {
        saveView(null, list);
        // Automatyczne doczytanie nie przejmuje klawiatury i nie przewija strony.
        if (source === 'manual') { var link = itemLink(items[0]); if (link) link.focus({ preventScroll: true }); }
        track('load_more_success', { page: pageNumber, shown: shown, total: Number(list.dataset.total), source: source });
      }
      document.dispatchEvent(new CustomEvent('dcm:grid:appended', { detail: { count: items.length } }));
      requestAnimationFrame(function () { rearm(box); });
      return true;
    } catch (err) {
      if (!isCurrent()) return false;
      box.dataset.autoPaused = 'true';
      box.classList.add('dcm-more--error');
      if (error) error.hidden = false;
      if (source !== 'restore') track('load_more_error', { page: pageNumber, shown: listItems(list).length, total: Number(list.dataset.total), source: source });
      return false;
    } finally {
      clearTimeout(timeout);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = t('load_more');
      if (activeRequest === request) activeRequest = null;
    }
  }
  async function restoreHistory() {
    var saved = history.state && history.state.dcmListing;
    if (!saved) return;
    var lists = Array.prototype.slice.call(document.querySelectorAll('[data-dcm-list]'));
    for (var k = 0; k < lists.length; k++) await restoreList(lists[k], saved);
  }
  async function restoreList(list, saved) {
    if (!list || saved.key !== viewKey(list) || restoredLists.has(list)) return;
    if (!Number.isInteger(saved.lastPage) || saved.lastPage <= Number(list.dataset.page) || saved.lastPage > Number(list.dataset.pages)) return;
    restoredLists.add(list);
    restoringList = list;
    try {
      while (list === currentList(list) && saved.key === viewKey(list) && Number(list.dataset.page) < saved.lastPage) {
        var box = boxFor(list), button = box && box.querySelector('[data-dcm-load]');
        if (!button || !await loadMore(button, 'restore')) return;
      }
      if (list !== currentList(list) || saved.key !== viewKey(list)) return;
      await new Promise(function (resolve) { requestAnimationFrame(resolve); });
      var item = listItems(list).find(function (el) { return el.dataset.dcmKey === saved.item; });
      var link = itemLink(item);
      if (link) link.focus({ preventScroll: true });
      if (Number.isFinite(saved.scrollY)) scrollTo(0, saved.scrollY);
    } finally {
      if (restoringList === list) restoringList = null;
    }
  }
  document.addEventListener('dcm:filters:start', function () {
    if (activeRequest) { activeRequest.controller.abort(); activeRequest = null; }
  });
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var podglad = event.target.closest('[data-dcm-preview]');
    if (podglad && podglad.dataset.gest) {
      // Palec przesunal klatke — to nie byl klik w kafel, wiec nie wchodzimy na karte produktu.
      delete podglad.dataset.gest;
      event.preventDefault();
      return;
    }
    var step = event.target.closest('[data-dcm-step]');
    if (step) {
      event.preventDefault();
      przesunKlatke(step.closest('[data-dcm-dawn-card]'), Number(step.dataset.dcmStep));
      return;
    }
    var rozmowa = event.target instanceof Element ? event.target.closest('[data-dcm-whatsapp]') : null;
    if (rozmowa) track('whatsapp_klik', { miejsce: rozmowa.dataset.dcmMiejsce || '' });
    var button = event.target.closest('[data-dcm-load]');
    if (button) { event.preventDefault(); loadMore(button, 'manual'); return; }
    var link = event.target.closest('[data-dcm-list] a[href]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      var item = link.closest('[data-dcm-key]');
      saveView({ item: item && item.dataset.dcmKey, scrollY: scrollY }, item);
    }
  });

  function init() {
    document.documentElement.classList.add('dcm-staging-ready');
    initMobileMarquees();
    window.DcmVisuals.initCards();
    window.DcmVisuals.initTiles();
    syncDensity();
    if (activeRequest && (!activeRequest.list.isConnected || activeRequest.list !== currentList(activeRequest.list))) { activeRequest.controller.abort(); activeRequest = null; }
    restoreHistory();
    observedSentinels.forEach(function (sentinel) {
      if (!sentinel.isConnected) { autoObserver.unobserve(sentinel); observedSentinels.delete(sentinel); }
    });
    document.querySelectorAll('[data-dcm-more]').forEach(function (box) {
      box.classList.add('dcm-more--ready');
      var sentinel = box.querySelector('[data-dcm-sentinel]');
      if (autoObserver && sentinel && !observedSentinels.has(sentinel)) {
        observedSentinels.add(sentinel);
        autoObserver.observe(sentinel);
      }
    });
  }

  function syncDensity() {
    var value = document.documentElement.dataset.dcmDensity || 'small';
    document.querySelectorAll('[data-dcm-density]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.dcmDensity === value)); });
    if (window.dcmApplyImageSizes) window.dcmApplyImageSizes(document);
  }
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element && event.target.closest('[data-dcm-density]');
    if (!button || !matchMedia('(min-width:990px)').matches) return;
    var value=button.dataset.dcmDensity;
    if (value===document.documentElement.dataset.dcmDensity) return;
    document.documentElement.dataset.dcmDensity=value;
    try { localStorage.setItem('dcm-photo-size',value); } catch (_) { try { sessionStorage.setItem('dcm-photo-size',value); } catch (_) {} }
    syncDensity();
    track('density_toggle',{density:value});
  });
  addEventListener('storage', function (event) {
    if (event.key==='dcm-photo-size') { document.documentElement.dataset.dcmDensity=event.newValue==='large'?'large':'small'; syncDensity(); }
  });

  function start() {
    init();
    var observer = new MutationObserver(function (mutations) {
      var changed = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-dcm-list],[data-dcm-more],[data-dcm-coltile],[data-dcm-dawn-card]') || node.querySelector('[data-dcm-list],[data-dcm-more],[data-dcm-coltile],[data-dcm-dawn-card]'));
        });
      });
      if (changed) init();
    });
    observer.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', init);
  addEventListener('pageshow', init);
  addEventListener('popstate', function () { if (activeRequest) { activeRequest.controller.abort(); activeRequest = null; } requestAnimationFrame(init); });
})();
